import { InjectionToken, Provider } from '@angular/core';
import {
  TOPICS_TREE_BADGE_COMPONENTS,
  TopicsTreeBadgeComponents,
} from './explorer/asset-tree-badge/topics-tree-badge-components';

export type TopicsTreeMode = 'student' | 'admin';

export const TOPICS_TREE_MODE = new InjectionToken<TopicsTreeMode>('topics_tree_mode');

export function provideTopicsTreeMode<T extends TopicsTreeMode>(
  mode: T,
  badgeComponents: TopicsTreeBadgeComponents<T>,
): Provider[] {
  return [
    { provide: TOPICS_TREE_MODE, useValue: mode },
    { provide: TOPICS_TREE_BADGE_COMPONENTS, useValue: badgeComponents },
  ];
}
